import { get, post } from "../https";

const api = "/xywapi";
export async function updateQuestion(data) {
  return await post(`${api}/feedbackWeb/addSurResult`, data);
}


export async function getQuestion(data) {
  return await get(`${api}/feedbackWeb/listAll/${data.id}`);
}

